<template>
  <div class="chatItem" @click="getRedPacket">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt />
    </div>
    <div class="chatWrap" :style="{backgroundColor:getIsFetch()?'#fce1c3':'#fa9e3b','--bgColor':bgColor}">
      <div class="left">
        <img src="https://qiniu.dljok.com/static/icon/h5/icon_redpacket.png"/>
        <span>微信红包</span>
      </div>
      <div class="wish">
        <span>{{ getWishMessage() }}</span>
        <span v-if="getIsFetch()" class="tip">已领取</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import {ImagePreview, Toast} from "vant";
import {mapGetters} from "vuex";
import i18nMixin from "@/libs/i18nMixin";
export default {
  name: "ChatRedPacket",
  mixins: [i18nMixin],
  props:{
    chatItem:{
      type: Object,
      default:{}
    }
  },
  data(){
    return{
      defaultAvatar: defaultAvatar,
      hasGet:false,
      bgColor:'#fa9e3b'
    }
  },
  mounted() {
    this.$Bus.$on("triggerHasGet", (val) => {
      if(this.chatItem.id === val.chatId){
        this.hasGet = val.hasGet;
      }
    });
  },
  beforeDestroy() {
    this.$Bus.$off("triggerHasGet");
  },
  computed: mapGetters(["userInfo"]),
  methods:{
    /**
     * 查询红包是否已领取/已获取
     * @returns {Promise<boolean>} 真实的领取状态（true=已领取/已获取，false=未领取）
     */
    getIsFetch() {
      let redPacketObj = JSON.parse(this.chatItem.chatContext);
      // 2. 初始化返回值，保留原业务初始值
      let isFetched = this.hasGet;
      const receiverList = redPacketObj.receiverICloudUserIdList;
      const currentUserId = this.userInfo.uid;
      if (Array.isArray(receiverList) && currentUserId && receiverList.includes(currentUserId)) {
        isFetched = true;
      }
      return isFetched;
    },
    getWishMessage() {
      try {
        // Parse the JSON string if it's a string
        const context = typeof this.chatItem.chatContext === 'string'
            ? JSON.parse(this.chatItem.chatContext)
            : this.chatItem.chatContext;
        // Return the desired property (adjust 'wish' to your actual property name)
        return context.wish || this.$i18n('congratulationsProsperity', '恭喜发财，大吉大利'); // fallback message
      } catch (e) {
        console.error('Error parsing chat context:', e);
        return this.$i18n('congratulationsProsperity', '恭喜发财，大吉大利'); // fallback message if parsing fails
      }
    },
    async getRedPacket() {
      // 1. 防重复点击：请求中直接返回，避免多次调用接口
      if (this.hasGet) return;
      // 2. 初始化加载中toast，做判空兜底
      let toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中...",
      });
      try {
        // 3. 红包信息解析：多层判空+JSON.parse异常捕获，避免解析失败报错
        let redPacketObj = JSON.parse(this.chatItem.chatContext);
        // 4. 第一个接口：查询红包剩余数量
        const getRes = await this.$http.get(
            `/chat/getRedPacket?redPacketId=${redPacketObj.id}&chatId=${this.chatItem.id}`
        );
        // 判空后端返回值，避免res.data为null/undefined时报错
        if (!getRes.data || getRes.data.number <= 0) {
          this.hasGet = true;
          this.bgColor = '#fce1c3';
          this.$toast("很遗憾，您来晚了！");
          this.$Bus.$emit("refreshMsg");
          return; // 无剩余直接退出，不执行后续领取逻辑
        }

        // 5. 构造领取红包的参数，修复原笔误问题
        const recordObj = { ...getRes.data, chatId: this.chatItem.id };
        // 6. 第二个接口：执行领取红包操作
        await this.$http.get("/chat/fetchRedPacket", {
          params: recordObj, // 修复：替换原未定义的this.redPacketRecordObj
        });

        // 7. 领取成功：更新状态+提示+触发总线事件（解开注释即可用）
        this.hasGet = true;
        this.bgColor = '#fce1c3';
        this.$toast("抢到了，请稍等！");
        this.$Bus.$emit("refreshMsg");
      } catch (err) {
        // 8. 异常兜底：友好提示，避免原生错误信息展示给用户
        const errMsg = err.message || "领取红包失败，请稍后再试";
        this.$toast(errMsg);
      } finally {
        // 9. 最终清理：无论成功/失败，关闭加载+释放请求锁
        setTimeout(()=>{
          toast.clear(); // 判空toast，防止创建失败时报错
        },800)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px; // 原30px

  .userInfo {
    margin-left: 25px; // 原50px
    img {
      width: 34px; // 原68px
      height: 34px; // 原68px
      border-radius: 50%;
    }
  }

  .chatWrap {
    display: flex;
    flex-direction: row;
    font-size: 13px; // 原26px
    font-weight: 500;
    line-height: 17px; // 原34px
    color: #fff;
    overflow-wrap: break-word;
    padding: 8px; // 原15px
    border-radius: 7px; // 原13px
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: -8px;  // 原16px
      top: 5px;    // 原10px
      width: 0;
      height: 0;
      border: 5px solid transparent; // 原10px
      border-right-color: var(--bgColor);
    }

    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 32px; // 原64px
      }

      span {
        font-size: 10px; // 原20px
        color: #f8c081;
      }
    }

    .wish {
      margin-top: 5px; // 原10px
      font-size: 13px; // 原26px
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 10px; // 原20px

      .tip {
        font-size: 12px; // 原24px
      }
    }
  }
}
</style>
